import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconColor, IconComponent } from '../icon';

export type SectionEmptyPreset = 'block' | 'inline';

@Component({
  selector: 'cm-section-empty',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
  ],
  templateUrl: './section-empty.component.html',
  styleUrl: './section-empty.component.less',
  host: {
    '[class.section-empty-host--inline]': "preset() === 'inline'",
  },
})
export class SectionEmptyComponent {
  public readonly preset = input<SectionEmptyPreset>('block');
  public readonly icon = input<string>('description');
  public readonly iconColor = input<IconColor>('neutral');
  public readonly title = input.required<string>();
  public readonly subtitle = input<string>('');
  public readonly buttonLabel = input<string>('');
  public readonly buttonIcon = input<string>('');
  public readonly buttonLoading = input<boolean>(false);

  public readonly create = output<void>();

  public onCreateClick(): void {
    this.create.emit();
  }
}
